import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

const NOT_NEEDED_SCROLLING_PATHNAMES = ['/users', '/biller'];

export class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location && this.isNeededScrollingPathname) {
      window.scrollTo(0, 0);
    }
  }

  get isNeededScrollingPathname() {
    if (!this.props.location.pathname) return true;

    return !(NOT_NEEDED_SCROLLING_PATHNAMES.some(pathname => this.props.location.pathname.indexOf(pathname) !== -1));
  }

  render() {
    return this.props.children;
  }
}

ScrollToTop.propTypes = {
  location: PropTypes.shape(),
  children: PropTypes.node,
};

ScrollToTop.defaultProps = {
  location: {},
  children: null,
};

export default withRouter(ScrollToTop);
